<ct-lib-modal
  #modal
  [label]="modalTitleKey() | transloco"
  [small]="!isAutoRenewalStep()"
  [hideFooter]="
    checkoutLoading() && !isPaymentMethodStep() && !isAutoRenewalStep()
  "
  [footer]="creditsBookingModalFooter"
  (onClose)="onMainShellClose()"
>
  <div class="credits-booking-modal">
    @if (isPaymentMethodStep()) {
      <app-payment-method-choice #paymentMethodChoice [busy]="choiceBusy()" />
    } @else if (isAutoRenewalStep()) {
      <p class="intro auto-renewal-intro">
        {{
          'company-tool.snippets.credits-booking-modal.auto-renewal.intro'
            | transloco
        }}
      </p>
      <app-credits-auto-renewal-setup
        #autoRenewalSetup
        [canEnable]="true"
        [startEnabled]="true"
      />
    } @else if (!showCheckout()) {
      @if (bookingAmount() > 0) {
        @if (budgetExceeded()) {
          <p
            class="intro"
            [innerHTML]="
              'company-tool.snippets.credits-booking-modal.budget-exceeded-description'
                | transloco
                  : {
                      amount: bookingAmountFormatted(),
                    }
            "
          ></p>
        } @else {
          <p
            class="intro"
            [innerHTML]="
              'company-tool.snippets.credits-booking-modal.description'
                | transloco
                  : {
                      amount: bookingAmountFormatted(),
                    }
            "
          ></p>
        }
      }

      @if (!isUserAdmin()) {
        <p class="admin-hint">
          {{
            'company-tool.snippets.credits-booking-modal.admin-info' | transloco
          }}
        </p>
      }

      @if (creditsPackagesLoaded() && creditsPackages().length === 0) {
        <p class="empty-state">
          {{ 'company-tool.snippets.credits-booking-modal.empty' | transloco }}
        </p>
      } @else {
        <app-credits-package-selector
          [packages]="creditsPackages()"
          [loaded]="creditsPackagesLoaded()"
          [disabled]="!isUserAdmin() || checkoutLoading()"
          [(selectedOption)]="selectedOption"
          [(customPackageCount)]="customPackageCount"
        />
      }
    } @else {
      @if (checkoutLoading()) {
        <div class="checkout-loading">
          <ct-lib-spinner></ct-lib-spinner>
        </div>
      }
      <div id="payment-setup-checkout-element"></div>
    }
  </div>
</ct-lib-modal>

<ng-template #creditsBookingModalFooter>
  @if (isAutoRenewalStep()) {
    <app-button variant="white-grey" (click)="skipAutoRenewal()">
      {{
        'company-tool.snippets.credits-booking-modal.auto-renewal.skip'
          | transloco
      }}
    </app-button>
    <app-button
      [loading]="choiceBusy()"
      [disabled]="choiceBusy() || !canConfirmAutoRenewal()"
      (click)="confirmAutoRenewal()"
    >
      {{
        'company-tool.snippets.credits-booking-modal.auto-renewal.enable'
          | transloco
      }}
    </app-button>
  } @else if (isPaymentMethodStep()) {
    <app-button variant="white-grey" (click)="backFromPaymentMethod()">
      {{ 'company-tool.snippets.payment-method-choice.back' | transloco }}
    </app-button>
    <app-button
      [loading]="choiceBusy()"
      [disabled]="choiceBusy()"
      (click)="confirmPaymentMethod()"
    >
      {{ 'company-tool.snippets.payment-method-choice.continue' | transloco }}
    </app-button>
  } @else if (showCheckout()) {
    <app-button variant="white-grey" (click)="backToSelection()">
      {{ 'company-tool.snippets.credits-booking-modal.back' | transloco }}
    </app-button>
  } @else {
    <app-button
      [disabled]="!canBook() || choiceBusy()"
      [loading]="choiceBusy()"
      (click)="bookSelectedPackage()"
    >
      {{ 'company-tool.snippets.credits-booking-modal.button' | transloco }}
    </app-button>
  }
</ng-template>

<ct-lib-modal
  [label]="
    'company-tool.snippets.credits-booking-confirmation-modal.title' | transloco
  "
  [closeable]="false"
  [footer]="confirmationFooter"
  #confirmationModal
  >{{
    'company-tool.snippets.credits-booking-confirmation-modal.description'
      | transloco
        : {
            amount: bookingAmountFormatted(),
            leftCredits: bookingLeftCreditsFormatted(),
          }
  }}
</ct-lib-modal>

<ng-template #confirmationFooter>
  <div class="footer">
    <app-button variant="white-grey" (click)="cancel()">
      {{
        'company-tool.snippets.credits-booking-confirmation-modal.cancel'
          | transloco
      }}
    </app-button>
    <div>
      <app-button variant="white-grey" (click)="backToBooking()">
        {{
          'company-tool.snippets.credits-booking-confirmation-modal.back-to-booking'
            | transloco
        }}
      </app-button>
      <app-button variant="primary" (click)="continueWithCredits()">
        {{
          'company-tool.snippets.credits-booking-confirmation-modal.continue-with-credits'
            | transloco
        }}
      </app-button>
    </div>
  </div>
</ng-template>

<app-invoice-booking-confirm-modal
  #invoiceConfirm
  (confirmed)="onInvoiceBookingConfirmed()"
></app-invoice-booking-confirm-modal>
